export default __webpack_public_path__ + "static/Nox3-f065b25a057d478e2dd4b409e55cc476.png";